import { screenToStudio, studioToScreen } from "@logic/lib/design"
import { useRecoilTransaction_UNSTABLE } from "recoil"

import { invertPoint } from "~/containers/LegacyDesigner/state/scroll"

import type { TransactionOperation } from "."
import { changePan } from "./changePan"
import { getMousePositionOnScreen } from "./getMousePosition"
import { zoomState } from "../../view"

export const zoomAroundMouse: TransactionOperation<(zoom: number) => number> = (
  transactors,
  transformZoom,
) => {
  const { set, get } = transactors
  const zoom = get(zoomState)
  const newZoom = transformZoom(zoom)
  const mousePositionOnScreen = getMousePositionOnScreen(transactors)
  const mousePositionInStudio = screenToStudio.point(mousePositionOnScreen, zoom)
  const newZoomedMousePositionInStudio = screenToStudio.point(
    mousePositionOnScreen,
    newZoom,
  )
  const mousePositionChange = {
    x: newZoomedMousePositionInStudio.x - mousePositionInStudio.x,
    y: newZoomedMousePositionInStudio.y - mousePositionInStudio.y,
  }
  // console.debug({ zoom })
  // console.debug({ newZoom })
  // console.debug(`mousePositionOnScreen`, mousePositionOnScreen)
  // console.debug(`mousePositionInStudio`, mousePositionInStudio)
  // console.debug(`newZoomedMousePositionInStudio`, newZoomedMousePositionInStudio)
  // console.debug(`mousePositionChange`, mousePositionChange)
  set(zoomState, newZoom)
  changePan(
    transactors,
    studioToScreen.point(invertPoint(mousePositionChange), newZoom),
  )
}

export type ZoomAroundMouse = (transformZoom: (zoom: number) => number) => void

export const useZoomAroundMouse = (): ZoomAroundMouse =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => (transformZoom) =>
      zoomAroundMouse(transactors, transformZoom),
  )
